import { render, staticRenderFns } from "./NXTSelfDeptUserSelector.vue?vue&type=template&id=594fe156&scoped=true"
import script from "./NXTSelfDeptUserSelector.vue?vue&type=script&lang=js"
export * from "./NXTSelfDeptUserSelector.vue?vue&type=script&lang=js"
import style0 from "./NXTSelfDeptUserSelector.vue?vue&type=style&index=0&id=594fe156&prod&scoped=true&lang=css"
import style1 from "./NXTSelfDeptUserSelector.vue?vue&type=style&index=1&id=594fe156&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594fe156",
  null
  
)

export default component.exports